import { Component, OnInit } from '@angular/core';
import { AuthService } from '../loginCore/auth.service';
import { Router } from '@angular/router';
import { LoadingService } from '../loading.service';
import { UserService } from '../loginCore/user.service';
import { ClaimService } from '../claim.service';
import { UtilService } from '../util.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  isHR: boolean;

  constructor(public authService: AuthService, private router: Router, public loadingService: LoadingService,public userService: UserService,public claimService:ClaimService,public utilService:UtilService) { }
 errMsg: string;
 ngOnInit() {
  this.loadingService.disableLoading();

}
ngAfterViewInit() {
  this.loadingService.enableLoading();
  setTimeout(() => {
    this.authService.handleSamlRedirect()
      .then(
        res => {
          const canLogin = !!res;
          if (canLogin) {
          //  this.claimService.getFamilyMembers().subscribe(familyMembers => {

          //     const selfMember = familyMembers.find(m => m.relationship === "Self");
          //     if (selfMember) {
          //       const displayName = `${selfMember.firstName} ${selfMember.lastName}`.trim();
          //       this.userService.setUserName(displayName);
          //     }

              // Now navigate
              this.router.navigate(['/home']);
            // });
          } else {
            console.log('No user yet');
          }
          this.loadingService.disableLoading();
        },
        err => {
          console.error(err);
          this.loadingService.disableLoading();
        }
      );
  }, 500);
}

  tryGoogleLogin(){
    this.authService.doGoogleLogin()
    .then(res => {
      this.router.navigate(['/home']);
    }).then();
  }
trySamlLogin() {
    this.loadingService.enableLoading();
    this.authService.doSamlLogin();
  }
}
